import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchSection: {
    margin: '20px 0',
    padding: '24px 0',
  },
  searchWrapper: {
    display: 'flex',
    flex: '1',
    gap: '16px',
    padding: '24px 0',
    '& .label': {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '20px',
    },
  },
  search: (getGridsWidth: (width: number, noGap: boolean) => number) => ({
    minWidth: `${getGridsWidth(2, true)}px`,
    flexGrow: '1',
  }),
  developer: (getGridsWidth) => ({
    minWidth: `${getGridsWidth(2, true)}px`,
    flexGrow: '1',
  }),
  role: (getGridsWidth) => ({
    minWidth: `${getGridsWidth(1, true)}px`,
    flexGrow: '1',
  }),
  status: (getGridsWidth) => ({
    minWidth: `${getGridsWidth(1, true)}px`,
    flexGrow: '1',
  }),
  root: {
    width: 44,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  focusVisible: {},
  thumb: {},
}));
